import { useMemo, useState } from 'react';
import { useWallet } from '@solana/wallet-adapter-react'
import * as anchor from '@project-serum/anchor';
import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";
import { clusterApiUrl } from "@solana/web3.js";
import {
  getPhantomWallet,
  getSlopeWallet,
  getSolflareWallet,
  getSolletWallet,
  getSolletExtensionWallet,
} from "@solana/wallet-adapter-wallets";
import {
  ConnectionProvider,
  WalletProvider,
} from "@solana/wallet-adapter-react";
import { WalletDialogProvider } from "@solana/wallet-adapter-material-ui";
import { 
  CandyMachineAccount,
  getCandyMachineState
} from "../components/homepage/candy-machine";
import StatScreen from "../components/game/StatScreen";

export interface GameProps {
  candyMachineId?: anchor.web3.PublicKey;
  connection: anchor.web3.Connection;
  startDate: number;
  txTimeout: number;
  rpcHost: string;
}

const Gamepage = (props: GameProps) => {
  const { publicKey, signTransaction, sendTransaction } = useWallet()
  const [candyMachine, setCandyMachine] = useState<CandyMachineAccount>();
  const rpcUrl = props.rpcHost;
  const wallet = useWallet();
  const network = process.env.REACT_APP_SOLANA_NETWORK as WalletAdapterNetwork;
  const connection = new anchor.web3.Connection(
    props.rpcHost ? props.rpcHost : anchor.web3.clusterApiUrl("mainnet-beta")
  )
  const endpoint = useMemo(() => clusterApiUrl(network), []);
  const wallets = useMemo(
    () => [
      getPhantomWallet(),
      getSlopeWallet(),
      getSolflareWallet(),
      getSolletWallet({ network }),
      getSolletExtensionWallet({ network }),
    ],
    []
  );
  return (
    <ConnectionProvider endpoint={endpoint}>
      <WalletProvider wallets={wallets} autoConnect={true}>
        <WalletDialogProvider>
          {/* <GameSection
            candyMachineId={props.candyMachineId}
            connection={props.connection}
            startDate={props.startDate}
            txTimeout={props.txTimeout}
            rpcHost={props.rpcHost}
          /> */}
          <StatScreen
              candyMachineId={props.candyMachineId}
              connection={props.connection}
              startDate={props.startDate}
              txTimeout={props.txTimeout}
              rpcHost={props.rpcHost}
          />       
        </WalletDialogProvider>
      </WalletProvider>
    </ConnectionProvider>
  )
};

export default Gamepage;
